import { render } from "./StudentList.vue?vue&type=template&id=6d51c2c8"
import script from "./StudentList.vue?vue&type=script&lang=js"
export * from "./StudentList.vue?vue&type=script&lang=js"

import "./StudentList.vue?vue&type=style&index=0&id=6d51c2c8&lang=scss"
script.render = render

export default script